export default {
    ORDER_LIMIT_ALERT_DAY:5,
    ORDER_LIMIT_ALERT_DAY_MESSAGE:'月末まで${end_date}日です。本当に発注が必要か管理者にご確認ください。',
    TAX_TOTAL_TYPES:[
        {id:0,name:'合計金額に消費税を加算する(外税)'},
        {id:1,name:'合計金額に消費税を加算しない(内税)'},
    ],
    AMOUNT_FLOAT_TYPES:[
        {id:0,name:'切り捨て'},
        {id:1,name:'四捨五入'},
        {id:2,name:'切り上げ'},
    ],
    STOCK_MODES:{
        '棚卸':0,
        '廃棄':1,
    },
    STOCK_REASONS:[
        {id:-1,name:'全て'},
        {id:0,name:'紛失'},
        {id:1,name:'破損'},
        {id:2,name:'期限切れ'},
        {id:3,name:'返品'},
        {id:4,name:'零売'},
        {id:5,name:'その他'},
    ],
    DRUG_TYPES : {
        'poison':'毒',
        'dramatic_drug':'劇薬',
        'hemp_drug':'麻薬/覚醒',
        'psychotropic_drug':'向精神薬',
        'cold_place':'冷所',
    },
    USE_CATEGORY_CODES : {
        '内用薬':1,
        '外用薬':3,
    },
    MEDICINE_TYPES: {
        'メディコード医薬品':0,
        '医療材料・医療機器':1,
        'OTC・雑貨':2,
    },
    PACK_ACTIONS : {
        '承認':1,
        '取消':2,
        '発送':3,
        '発送待ち':4,
    },
    PACK_STATUSES : {
        '承認待ち':1,
        '発送待ち':2,
    },
    NOTIFICATION_TYPES : {
        '通常':0,
        '重要':1,
        '緊急':2,
    },
    HELP_ACTION_KEY_TYPES : {
        'ID':1,
        'クラス':2,
        'ラベル':3,
    },
    STOCK_TYPES_OPTIONS:[
        {id:-1,name:'全て'},
        {id:0,name:'処方'},
        {id:1,name:'卸'},
        {id:2,name:'小分け'},
        {id:3,name:'棚卸'},
    ],
    STOCK_TYPES : {
        '処方':0,
        'VAN':1,
        '小分け':2,
        '棚卸':3,
    },
    ORDER_STATUSES : {
        '自動':0,
        '手動':1,
        '保留':2,
        '代替':3,
    },
    ESTIMATE_CSV_HEADER : {
        'JANコード': 0,
        '卸単価': 1,
        '薬価': 2,
        '取引数量': 3,
        '採用品名': 4,
        '薬品タイプ': 5,
        '使用区分コード': 6,
        '販売元': 7,
        '製造元': 8,
        'システムＩＤ１': 9,
        'システムＩＤ２': 10,
        'システムＩＤ３': 11,
    },
    NON_MEDICINE_TYPES : {
        '医療材料・医療機器':1,
        'OTC・雑貨':2,
    },
    NON_MEDICINE_TYPES_OPTIONS : [
        {id:1,name:'医療材料・医療機器'},
        {id:2,name:'OTC・雑貨'},
    ],
    VAN_CREATE_TYPES : {
        '通常納品':0,
        '発注無し納品':1,
        '新薬納品':2,
        '返品':3,
        '分割納品':4,
    },
    PACK_NUMBER_VISIBLE_TYPE : {
        '表示しない':0,
        '表示する':1,
    },
    SPAPP_MENU : {
        '監査チェック':'audit_check',
        '発注':'order',
        '棚卸':'stock_control',
        '納品確認':'delivery_confirmation',
        'WEB':'web',
        'HOME':'home',
        '履歴':'barcode_history',
        'ログイン':'login',
    },
    SPAPP_SOUND : {
        '通常':'default',
        'エラー':'error',
        '完了':'complete',
    },
    DEFAULT_TAX : 10,
    LIST_DELAY : 3000,
}
